import { createDynamicSlice } from ".";
import { getProjectCodeListThunk } from "../thunks/projectCodesThunk";

export const projectCodesSlice = createDynamicSlice({
  name: "projectCodes",
  thunk: getProjectCodeListThunk,
  listMode: true,
  resetActionName: "resetProjectCodes",
});

export const projectCodesReducer = projectCodesSlice.reducer;
export const { resetProjectCodes } = projectCodesSlice.actions;
